import React from 'react';
import styled from 'styled-components';

const UserIconSVG = styled.svg(
  props => `
  height: ${props.height};
  fill: ${props.fill};
`,
);

// 🐨 type props as 'themeprops' + 'valid passed css props'
const UserIcon = props => (
  <UserIconSVG viewBox="0 0 32 32" {...props}>
    <path d="M21.185 3.148a7.333 7.333 0 11-10.37 10.371 7.333 7.333 0 0110.37-10.371zM16 17.667c-6.992.008-12.659 5.674-12.667 12.667 0 .368.298.667.667.667h24a.667.667 0 00.667-.667C28.659 23.342 22.993 17.675 16 17.667z" />
  </UserIconSVG>
);

export default UserIcon;
